var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMagicStarGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.645,
    height: 25.808,
    viewBox: "0 0 25.645 25.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_magic-star",
    "data-name": "vuesax/bold/magic-star",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magic-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H23.456V23.456H0Z",
    transform: "translate(0.32 0.337)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.844,2.092l-.068,3.7A2.033,2.033,0,0,0,15.5,7.281l2.424,1.837c1.554,1.173,1.3,2.609-.557,3.2l-3.157.987a2.037,2.037,0,0,0-1.222,1.28l-.753,2.873c-.6,2.267-2.082,2.492-3.313.5L7.2,15.168a2.012,2.012,0,0,0-1.642-.86L2.3,14.474c-2.336.117-3-1.231-1.476-3.01L2.755,9.216a2.034,2.034,0,0,0,.362-1.73l-1-3.167c-.577-1.857.459-2.883,2.306-2.277l2.883.948a2.039,2.039,0,0,0,1.632-.254l3.01-2.17C13.584-.6,14.883.088,14.844,2.092Z",
    transform: "translate(0 8.599) rotate(-27)",
    fill: "#FFA500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicStarGold);
export default __webpack_public_path__ + "static/media/icon-magic-star-gold.ae05c4d433a7d01166286cb1c355c262.svg";
export { ForwardRef as ReactComponent };